import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => (
  {
    root: {
      margin: '0 -10px',
      width: 'calc(100% + 20px)',
      display: 'flex',
      flexWrap: 'wrap',
    },
    halfSizeInputs: {
      // display: 'flex',
      // flexWrap: 'wrap',
      '& .form-element-wrapper': {
        width: '50%',
      }
    }
  }
))

// Stylistic wrapper for form fields
export const FormFieldWrapper = ({classes:propsClasses='', ...props}) => {
  
  const classes = useStyles();
 
 return (
    <div className={`${classes.root} ${props.halfSizeInputs ? classes.halfSizeInputs : ''} ${propsClasses}`}>
      {props.children}
    </div>
 )

}